<template>
    <div class="view-qualify-step-need-and-application qualify-sidebar">
        NEED AND APPLICATION CONTENT
    </div>
</template>

<script>
    export default {
        name: 'QualifyIndustryNeedAndApplication',
        data() {
            return {

            }
        },
        created(){
            this.$store.commit('qualifyIndustry/setNextStepAllowed', true);
        }
    }
</script>

<style lang="scss">
.view-qualify-step-need-and-application {

}
</style>
